import angular from 'angular';
import ButtonComponent from './button.component';

const button = angular
	.module('frButton', [])
	.component('frButton', ButtonComponent)
	.name;

export default button;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/button/button.module.js